export const getTiposGases = (state) => state.tiposGases.lista
export const getIsSavingTiposGases = (state) => state.tiposGases.isSaving
export const getIsCarregandoListaTiposGases = (state) => state.tiposGases.isCarregandoLista
export const getIsUpdatingTiposGases = (state) => state.tiposGases.isUpdating
